import "./index.scss";

import type { ReactNode, ComponentProps } from "react";
import classnames from "classnames";

import { Portal } from "util/html";
import Overlay from "common/modals/overlay";

type Props = {
  size?: "medium" | "large";
  children: ReactNode;
  overlayBackground?: ComponentProps<typeof Overlay>["background"];
  noBorder?: boolean;
};

function PlainModal({ children, size = "medium", overlayBackground = "grey", noBorder }: Props) {
  const cx = classnames("PlainModal", `PlainModal__${size}`, {
    "PlainModal__no-border": noBorder,
  });

  return (
    <Portal>
      <Overlay background={overlayBackground} sensitive={false}>
        <div className={cx}>{children}</div>
      </Overlay>
    </Portal>
  );
}

export default PlainModal;
